import React, { useRef } from "react";
import Slider from "react-slick";
import "./Partners.css";

// Partner data
const partnerData = [
  {
    image: require("../assets/partner-1.png"),
  },
  {
    image: require("../assets/partner-2.png"),
  },
  {
    image: require("../assets/partner-3.png"),
  },
    {
    image: require("../assets/kolkata thunderbolts.jpeg"),
  },
    {
    image: require("../assets/titans track.jpeg"),
  },
  {
    image: require("../assets/partner-4.png"),
  },
  {
    image: require("../assets/partner-5.png"),
  },
    {
    image: require("../assets/partner-6.png"),
  },
];

const Partners = () => {
  const sliderRef = useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <section className="partners-section">
      <div className="partners-header">
        <h2>
          Trusted <span className="partners-highlight-text">Partnership</span>
        </h2>

      </div>
      <p className="partners-sub">We are proud to announce our trusted collaboration partners</p>

      <Slider {...settings} ref={sliderRef}>
        {partnerData.map((partner, idx) => (
          <div className="partners-card-wrapper" key={idx}>
            <div className="partners-card">
              <img src={partner.image} alt={`Partner ${idx + 1}`} />
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default Partners;